import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Actions,
  Container,
  LinkButton,
  LinksContainer,
  Main,
  ReportContent,
  Title,
  // TopButton,
} from './code.style';
import { Button } from '../../../components/uielements';

const Code = () => {
  const navigate = useNavigate();

  const handleNavigateToReviewLodge = () => {
    navigate('/reviewAndLodge');
  };

  return (
    <Container>
      {/* <TopButton>CODE ASSESSABLE</TopButton> */}
      <Title>PLANNING APPLICATION REPORT</Title>

      <Main>
        <ReportContent>
          <p>
            <strong>Etiam laoreet ligula nec ultrices suscipit.</strong>
          </p>
          <p>Donec sit amet porttitor elit.</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam laoreet ligula nec
            ultrices suscipit. Donec sit amet porttitor elit.
          </p>

          <p>
            <strong>Etiam laoreet ligula nec ultrices suscipit.</strong>
          </p>
          <p>Donec sit amet porttitor elit.</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam laoreet ligula nec
            ultrices suscipit. Donec sit amet porttitor elit.
          </p>
        </ReportContent>
      </Main>
      <Actions>
        <Button onClick={handleNavigateToReviewLodge}>WATCH</Button>
        <LinksContainer>
          <Button href="#">Email Copy</Button>
          <Button href="#">Start New Project</Button>
        </LinksContainer>
      </Actions>
    </Container>
  );
};

export default Code;
